<template>
  <div class="nav">
    <ul>
      <li v-for="item,index in navList" :key="index" :class="{'border':index == i}" @click="tab(index)" v-show="item.isAuth">
        <router-link style="width:100%;display:block;" :to="item.href">{{item.name}}</router-link>
      </li>
    </ul>
  </div>
</template>
<script>
import { AccountApi } from '../axios/index'

export default {
  data(){
    return{
      i: 0,
      navList:[
        {
          name:"首页",
          href:"/home/index"
        },
        {
          name:"广告",
          href:"/home/ad"
        },
        {
          name:"推广报告",
          href:"/home/extenAD"
        },
        // {
        //   name:"财务",
        //   href:"/home/finance"
        // },
        {
          name:"账号管理",
          href:"/home/account"
        },
        {
          name:"对账系统",
          href:"/home/reconciliation"
        },
        // {
        //   name:"消息中心",
        //   href:"/home/message"
        // }
      ]
    }
  },
  created(){
    this.getIsAuth();
  },
  methods:{
    tab(index){
      this.i = index;
    },
    getIsAuth(){
      AccountApi.getDetail().then((re)=>{
        let page = window.location.pathname;
        this.navList.forEach((item, index)=>{
          if(index == 4){
            this.$set(item,"isAuth", true);
          } else {
            this.$set(item,"isAuth", re.data.isAuth == true);
          }
          if(page == item.href){
            this.tab(index)
          }
        });
      });

    }
  }
}
</script>
<style scoped>
  .nav{
    width: 200px;
    height: calc(100% - 80px);
    min-height:100%;
    background: #FFFFFF;
    box-shadow: 0 0 0px 0 rgba(0,0,0,0.10);
    padding-top: 40px;
    position: fixed;
    left: 0;
  }
  .nav ul li {
    font-size: 18px;
    color: #424753;
    height: 40px;
    line-height: 40px;
    width: 148px;
    /* border-left: 4px solid #2E62C9; */
    border-left: 4px solid #fff;
    padding-left: 48px;
    margin-bottom: 40px;
    cursor: pointer;
  }
  .border,.nav ul li:hover{
    border-left: 4px solid #2E62C9 !important;
  }
  .border a,.nav ul li:hover a{
    color: #1976D2 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/nav.vue